export default __webpack_public_path__ + "static/set-us-apart-2-8337cbe5667fa2d021c332e812404fd9.jpg";